(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-competition/assets/javascripts/competition.js') >= 0) return;  svs.modules.push('/components/tipsen/route-competition/assets/javascripts/competition.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const _ReactRouterDOM = ReactRouterDOM,
  useRouteMatch = _ReactRouterDOM.useRouteMatch,
  useHistory = _ReactRouterDOM.useHistory;
const Lobby = svs.components.marketplaceCompetition.lobby.Lobby;
const CompetitionProvider = svs.components.marketplaceCompetition.competitionContext.CompetitionProvider;
const CompetitionMenuProvider = svs.components.marketplaceCompetition.competitionMenu.CompetitionMenuProvider;
const useDraws = svs.components.tipsen.routeCompetition.useDraws;
const useGetCompetitionStatus = svs.components.tipsen.hooks.useGetCompetitionStatus;
const selectEngineDefinition = svs.components.tipsen.engine.selectors.selectEngineDefinition;
const _svs$components$marke = svs.components.marketplaceCompetition.services.hooks,
  useCompetition = _svs$components$marke.useCompetition,
  useCompetitionBranding = _svs$components$marke.useCompetitionBranding,
  useIsCompetitionInCurrentProduct = _svs$components$marke.useIsCompetitionInCurrentProduct;
const _svs$components$marke2 = svs.components.marketplaceCompetition.services.actions.playerCompetitionActions,
  fetchPlayerCompetitions = _svs$components$marke2.fetchPlayerCompetitions,
  fetchPlayerCompetitionDrawStatus = _svs$components$marke2.fetchPlayerCompetitionDrawStatus;
const _svs$components$marke3 = svs.components.marketplaceCompetition.services.selectors.competitionSelectors,
  selectPlayerCompetition = _svs$components$marke3.selectPlayerCompetition,
  selectPlayerCompetitionDraws = _svs$components$marke3.selectPlayerCompetitionDraws;
const competitionHandler = svs.components.marketplaceCompetition.competitionHandler.competitionHandler;
const CompetitionSubscription = svs.components.marketplaceCompetition.competitionSubscription.CompetitionSubscription;
const RouteCompetition = () => {
  var _currentEngineDefinti, _competition$details;
  const match = useRouteMatch();
  const currentEngineDefintion = useSelector(selectEngineDefinition);
  let productId = currentEngineDefintion === null || currentEngineDefintion === void 0 || (_currentEngineDefinti = currentEngineDefintion.drawProductIds) === null || _currentEngineDefinti === void 0 ? void 0 : _currentEngineDefinti[0];
  const activeCompetition = competitionHandler().getActiveCompetition(productId);
  const competitionId = activeCompetition === null || activeCompetition === void 0 ? void 0 : activeCompetition.getCompetitionId();
  const competitionStatus = useGetCompetitionStatus(currentEngineDefintion, competitionId);
  const history = useHistory();
  useEffect(() => {
    if (!competitionId && competitionId !== 0 || !competitionStatus) {
      history.replace('/');
    }
  }, [competitionStatus, history, competitionId]);
  const competition = useCompetition(competitionId);
  const competitionBranding = useCompetitionBranding(competition === null || competition === void 0 ? void 0 : competition.compType);
  productId = competition === null || competition === void 0 || (_competition$details = competition.details) === null || _competition$details === void 0 ? void 0 : _competition$details.productId;
  const isCompetitionInCurrentProduct = useIsCompetitionInCurrentProduct(productId, currentEngineDefintion === null || currentEngineDefintion === void 0 ? void 0 : currentEngineDefintion.drawProductIds);
  const playerCompetition = useSelector(state => selectPlayerCompetition(state));
  const signUpsCompetitions = playerCompetition.signUps.competitions;
  const hasSignUpsCompetitions = Object.keys(signUpsCompetitions).length > 0;
  const dispatch = useDispatch();
  const isActiveOnly = true;
  useEffect(() => {
    if (isCompetitionInCurrentProduct && !hasSignUpsCompetitions) {
      dispatch(fetchPlayerCompetitions({
        isActiveOnly
      }));
    }
  }, [isCompetitionInCurrentProduct, hasSignUpsCompetitions, competitionId, isActiveOnly, dispatch]);
  const playerCompetitionDraws = useSelector(state => selectPlayerCompetitionDraws(state));
  const hasPlayerCompetitionDraws = Object.keys(playerCompetitionDraws).length > 0;
  const isCurrentCompetitonInPlayerCompetitions = hasSignUpsCompetitions && Boolean(signUpsCompetitions[competitionId]);
  useEffect(() => {
    if (isCompetitionInCurrentProduct && !hasPlayerCompetitionDraws && isCurrentCompetitonInPlayerCompetitions) {
      dispatch(fetchPlayerCompetitionDrawStatus(competitionId));
    }
  }, [isCompetitionInCurrentProduct, hasPlayerCompetitionDraws, isCurrentCompetitonInPlayerCompetitions, competitionId, dispatch]);
  const getMenuItems = () => {
    const menuItems = [];
    const couponItem = {
      ariaLabel: 'Översikt för tävlingen',
      label: 'Översikt',
      icon: 'nav-home',
      selectedOnPaths: ['/tavlingar/:competitionName', '/tavlingar/:competitionName/lag/:teamId'],
      to: {
        pathname: ''
      }
    };
    const couponItem2 = {
      ariaLabel: 'Ställning i tävlingen',
      label: 'Ställning',
      icon: 'nav-results',
      selectedOnPaths: ['/tavlingar/:competitionName/resultat'],
      to: {
        pathname: '/resultat'
      }
    };
    const couponItem3 = {
      ariaLabel: 'Om tävlingen',
      label: 'Om tävlingen',
      icon: 'information',
      selectedOnPaths: ['/tavlingar/:competitionName/om'],
      to: {
        pathname: '/om'
      }
    };
    menuItems.push(couponItem);
    menuItems.push(couponItem2);
    menuItems.push(couponItem3);
    return menuItems;
  };
  return React.createElement(CompetitionProvider, {
    competitionId: competitionId,
    useDraws: useDraws
  }, competitionId && React.createElement(CompetitionSubscription, {
    competitionId: competitionId
  }), React.createElement(CompetitionMenuProvider, {
    branding: competitionBranding,
    items: getMenuItems(),
    relativeTo: match
  }, React.createElement(Lobby, null)));
};
setGlobal('svs.components.tipsen.routeCompetition.RouteCompetition', RouteCompetition);

 })(window);